// App.jsx
import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { FaThreads, FaInstagram, FaGithub } from "react-icons/fa6";
import Waitlist from "./Waitlist";
import WaitlistDone from "./WaitlistDone";
import DownloadAPK from "./DownloadAPK";
import "./App.css";
import HomePage from "./HomePage";

const Redirect = ({ to }) => {
    return (
        <div className="flex flex-col items-center justify-center h-screen gap-4">
            <p className="text-lg text-gray-700 text-center p-4">
                You have been redirected from the payment page. Please click the button below to continue.
            </p>
            <a href={to} className="bg-[#18a999] hover:bg-[#1e8e7e] text-white px-4 py-2 rounded">
                Click here to continue
            </a>
        </div>
    );
};

const App = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const features = [
        {
            title: "AI-powered autocomplete",
            description: "Get smart suggestions for your text messages directly within the app you're already using. No need to switch apps!",
            src: "screenshot1.gif",
            alt: "Smart Suggestions in Action",
        },
        {
            title: "Multilingual support",
            description:
                "Supports multiple languages and follows the tone and context automatically, ensuring your messages always match the context and style you need.",
            src: "screenshot2.jpg",
            alt: "Language Customization Screen",
        },
        {
            title: "Supports multiple apps",
            description:
                "Seamlessly integrates with popular texting and dating apps like WhatsApp, Instagram, Signal, LINE, Tinder, Hinge, and Heymandi.",
            src: "screenshot3.jpg",
            alt: "App Integration",
        },
    ];

    return (
        <Router>
            <div className="bg-[#fbf5f3] text-[#333] font-sans">
                <div className="fixed top-4 left-0 right-0 z-50 flex justify-center px-4">
                    <header className="w-full max-w-6xl bg-[#fbf5f3] bg-opacity-90 backdrop-blur-sm p-4 rounded-lg shadow">
                        <div className="flex flex-wrap items-center justify-between">
                            <a href="/">
                                <img
                                    src="/logo.webp"
                                    alt="Coreply Logo"
                                    className="h-8 cursor-pointer"
                                    onClick={(e) => {
                                        // e.preventDefault();
                                        // document.getElementById("hero").scrollIntoView({ behavior: "smooth" });
                                    }}
                                />
                            </a>
                            <button className="sm:hidden" onClick={toggleMenu}>
                                ☰
                            </button>
                            <nav
                                className={`${
                                    menuOpen ? "flex" : "hidden"
                                } sm:flex flex-col sm:flex-row w-full sm:w-auto mt-4 sm:mt-0 gap-4 sm:gap-8`}
                            >
                                <a
                                    href="/#features"
                                    className="hover:underline block text-center"
                                    onClick={(e) => {
                                        // e.preventDefault();
                                        // document.getElementById("features").scrollIntoView({ behavior: "smooth" });
                                        setMenuOpen(false);
                                    }}
                                >
                                    Features
                                </a>
                                <a
                                    href="/#pricing"
                                    className="hover:underline block text-center"
                                    onClick={(e) => {
                                        // e.preventDefault();
                                        // document.getElementById("pricing").scrollIntoView({ behavior: "smooth" });
                                        setMenuOpen(false);
                                    }}
                                >
                                    Pricing
                                </a>
                            </nav>
                        </div>
                    </header>
                </div>
                <Routes>
                    <Route
                        path="/"
                        element={<HomePage menuOpen={menuOpen} setMenuOpen={setMenuOpen} toggleMenu={toggleMenu} features={features} />}
                    />
                    <Route path="/waitlist" element={<Waitlist />} />
                    <Route path="/waitlist/done" element={<WaitlistDone />} />
                    <Route path="/downloadapk" element={<DownloadAPK />} />
                    <Route path="/iap/success" element={<Redirect to="coreply://success" />} />
                    <Route path="/iap/canceled" element={<Redirect to="coreply://canceled" />} />
                </Routes>
                <footer className="bg-[#e3dad7] p-6">
                    <div className="max-w-4xl mx-auto flex flex-col items-center gap-4">
                        <div className="flex items-center gap-2">
                            <a href="mailto:hello@coreply.app" className="hover:underline text-[#666]">
                                hello@coreply.app
                            </a>
                        </div>
                        <div className="flex gap-6 text-2xl">
                            <a
                                href="https://github.com/coreply/coreply"
                                className="hover:text-gray-800 text-gray-600"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FaGithub />
                            </a>
                            <a
                                href="https://www.threads.net/@coreply.app"
                                className="hover:text-gray-800 text-gray-600"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FaThreads />
                            </a>
                            <a
                                href="https://www.instagram.com/coreply.app/"
                                className="hover:text-gray-800 text-gray-600"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FaInstagram />
                            </a>
                        </div>
                        <p className="text-sm text-[#666]">&copy; 2025 Coreply. All rights reserved.</p>
                    </div>
                </footer>
            </div>
        </Router>
    );
};

export default App;
